import React from 'react'
import Pt from 'prop-types'

export default function Data({
  result,
}) {
  let guesses = result.guesses.toExponential(0)
  let guessWord = ''
  if (result.guesses < 1000000) {
    guesses = result.guesses
  } else if (result.guesses < 1000000000) {
    guesses = Math.round(result.guesses / 1000000)
    guessWord = ' million'
  }

  return (
    <div>
      We estimate it will take up to {guesses}{guessWord} guesses to crack your password. With current
      technology, <strong>it could take {result.crack_times_display.offline_slow_hashing_1e4_per_second} to
      crack your password</strong>.
    </div>
  )
}

Data.propTypes = {
  result: Pt.shape({
    crack_times_display: Pt.shape({
      offline_slow_hashing_1e4_per_second: Pt.string.isRequired,
    }).isRequired,
    guesses: Pt.number.isRequired,
  }).isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/Password/Data.jsx